import gql from "graphql-tag";

export default gql`
    mutation ($customerId: ID!) {
        deleteCustomer (customerId: $customerId) {
            success
        }
    }
`;
